// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1VYSA","head":"ProcedureTableInfo_head__1yZIQ"};